var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6458 10.0624C19.2376 9.65563 18.5757 9.65563 18.1673 10.0624L13.9783 14.2363L11.7606 12.0265C11.5646 11.8311 11.2987 11.7214 11.0213 11.7214C10.7441 11.7214 10.4782 11.8311 10.2821 12.0265L5.35387 16.937C4.9456 17.3438 4.9456 18.0033 5.35387 18.4102C5.55803 18.6136 5.8256 18.7153 6.09307 18.7153C6.36064 18.7153 6.62821 18.6135 6.83227 18.4102L11.0213 14.2364L13.239 16.4461C13.4351 16.6415 13.701 16.7512 13.9783 16.7512C14.2556 16.7512 14.5215 16.6415 14.7175 16.4461L19.6459 11.5356C20.0541 11.1288 20.0541 10.4693 19.6458 10.0624Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9545 2.08335H16.3333V1.04165C16.3333 0.466407 15.8652 0 15.2879 0H9.71209C9.1347 0 8.66665 0.466407 8.66665 1.04165V2.0833H2.04544C1.46805 2.0833 1 2.54971 1 3.12496V23.9583C1 24.5336 1.4681 25 2.04544 25H22.9546C23.5319 25 24 24.5336 24 23.9583V3.12501C24 2.54971 23.5319 2.08335 22.9545 2.08335ZM10.7575 2.08335H14.2424V3.1209C14.2424 3.12227 14.2422 3.12359 14.2422 3.12501C14.2422 3.12642 14.2424 3.12769 14.2424 3.12911V4.16666H10.7575V2.08335ZM21.9091 22.9167H3.09088V4.16666H8.66665V5.20831C8.66665 5.78361 9.13475 6.24996 9.71209 6.24996H15.2879C15.8652 6.24996 16.3333 5.78356 16.3333 5.20831V4.16666H21.9091V22.9167Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.5275bfe35062bd6348f02248e97ae225.svg";
export { ForwardRef as ReactComponent };